import { throttle } from "../../scripts/helpers";
import "./stripbar-pdp.scss";

if (!window.dAgency) window.dAgency = {};

window.dAgency.showOnScroll = (context) => {
  (function ($) {
    const button = $(".product__form__sticky-bottom");
    const stripbar = $(context);
    const cta = stripbar.find("a");

    if (button.length <= 0 || stripbar.length <= 0) {
      return false;
    }

    const activateStripbarSticky = function (stripbar, button) {
      const buttonTop = button.offset().top;
      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();
      
      if (buttonTop < windowTop || (buttonTop > windowBottom && $(window).height() > 900)) { 
        $(stripbar).addClass("show");
      } else {
        $(stripbar).removeClass("show");
      }
    };

    const returnToShop = function (cta) {
      $(cta).on("click", function (e) {
        e.preventDefault();
        $("html, body").animate(
          {
            scrollTop: $("#stripbar_pdp").offset().top - ($(window).height())/3,
          },
          350
        );
      });
    };

    window.addEventListener(
      "scroll",
      throttle(() => activateStripbarSticky(stripbar, button), 100)
    );

    activateStripbarSticky(stripbar, button);
    returnToShop(cta);
  })(jQuery);
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll(".stripbar-pdp"), (el) => {
    window.dAgency.showOnScroll(el);
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(document.querySelectorAll(".stripbar-pdp"), (el) => {
      window.dAgency.showOnScroll(el);
    });
  });
}
